import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import RowWithMessageTypeIcon from '@/components/misc/RowWithMessageTypeIcon'

function renderSelectView(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        label: this.label,
        hint: this.hint,
        items: this.$items,
        error: this.error,
        labelMode: this.labelMode,
        dense: this.dense,
        clearable: this.$clearable,
        details: !!this.hint,
        multiple: this.multiple,
        required: this.required,
        loading: this.loading,
        disabled: this.disabled || this.loading,
        readonly: this.readonly
      },
      scopedSlots: {
        selection: ({ item, removeByValue }) => {
          return h(
            RowWithMessageTypeIcon,
            {
              props: {
                title: item.title,
                value: item._item.type,
                dense: this.dense,
                as: 'tag',
                cancelable: this.cancelable,
                cancel: () => {
                  return removeByValue(item)
                }
              }
            }
          )
        }
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}

function renderButtonsView(h) {
  return h(
    'div',
    {
      class: 'fw grid-gap--8'
    },
    this.$items.map(({ title, value, type, disabled }) => {
      const hasValue = this.proxyHasValue(value)
      let mode = buttonModes.flat
      if (disabled) {
        mode = buttonModes.clear
      } else if (hasValue) {
        mode = buttonModes.filled
      }

      let color = Colors.description
      if (hasValue) {
        color = type
      }

      return h(
        button,
        {
          props: {
            label: title,
            size: this.size,
            mode,
            color,
            iconSVG: type,
            disabled: disabled ?? this.disabled
          },
          on: {
            click: () => {
              this.eventHandler(value)
            }
          }
        }
      )
    })
  )
}

export default function(h) {
  switch (this.view) {
    case 'buttons': return renderButtonsView.call(this, h)
    case components.select: return renderSelectView.call(this, h)
  }
}
